/**
 * Whether a learner belongs on a current-work surface.
 *
 * `status` is canonical when present. Legacy flags remain supported for older
 * active learner records that have not yet been migrated.
 */
export function isCurrentStudent(student) {
  if (!student) return false;

  const status = String(student.status || '').trim().toLowerCase();
  if (status) return status === 'active';

  return student.active !== false && student.graduated !== true;
}

export function filterCurrentStudents(students) {
  return Array.isArray(students) ? students.filter(isCurrentStudent) : [];
}
